export interface PopupRelations {
  productSlugs: string[];
  categorySlugs: string[];
  brandSlugs: string[];
}

export const getEmptyPopupRelations = (): PopupRelations => ({
  productSlugs: [],
  categorySlugs: [],
  brandSlugs: [],
});

export const popupRelationsFromResponse = (
  responseData: any,
): PopupRelations => ({
  productSlugs: responseData.product_slugs ?? [],
  categorySlugs: responseData.category_slugs ?? [],
  brandSlugs: responseData.brand_slugs ?? [],
});

export const popupRelationsToUpsertRequest = (
  popupRelations: PopupRelations,
): any => ({
  product_slugs: popupRelations.productSlugs,
  category_slugs: popupRelations.categorySlugs,
  brand_slugs: popupRelations.brandSlugs,
});
